export default __webpack_public_path__ + "static/AQP_Brochure_for_OlderAdults-98e3970eb2c82d90f5abcf6a650716d7.pdf";